import { ComponentType, IConfig } from '../../types';
import { BASIC_TANSLATE_TOOLTIP, ComponentConfigType } from '../../utils';
import { DateFormat } from '../../../utils/formatDate';
import {
  BASIC_JSON_LOGIC_TOOLTIP,
  BASIC_SELECT_VALUE_TOOLTIP,
  BASIC_SWITCH_VALUE_TOOLTIP,
  BASIC_VALUE_TOOLTIP,
  BASIC_VARIABLE_TOOLTIP,
} from '../../utils';

export const config: IConfig = {
  component: ComponentType.DateTime,
  configGroups: [
    {
      title: 'Component Properties',
      items: [
        {
          name: 'value',
          label: 'Date Value',
          valueComponent: {
            type: 'Input',
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'format',
          label: 'Format',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Date (DD.MM.YYYY.)', value: DateFormat.Date },
              {
                label: 'Date with Dash (YYYY-MM-DD)',
                value: DateFormat.DateWithDash,
              },
              {
                label: 'Year and Month (YYYY-MM)',
                value: DateFormat.YearAndMonth,
              },
              { label: 'Month Year (MMMM YYYY)', value: DateFormat.MonthYear },
              { label: 'Day Month (DD.MM.)', value: DateFormat.DayMonth },
              {
                label: 'Date and Time (DD.MM.YYYY, HH:mm)',
                value: DateFormat.DateAndTime,
              },
              {
                label: 'Date and Time with Seconds (DD.MM.YYYY, hh:mm:ss)',
                value: DateFormat.DateAndTimeSecond,
              },
              { label: 'Time Only (HH:mm)', value: DateFormat.Time },
            ],
            defaultValue: DateFormat.DateAndTime,
          },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'visible',
          label: 'Visible',
          valueComponent: { type: 'Switch', defaultValue: true },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'placeholder',
          label: 'Placeholder',
          valueComponent: { type: 'Input', defaultValue: 'Select Date' },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
            ComponentConfigType.Translate,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Variable,
              value: BASIC_VARIABLE_TOOLTIP,
            },
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
            {
              key: ComponentConfigType.Translate,
              value: BASIC_TANSLATE_TOOLTIP,
            },
          ],
        },
      ],
    },
    {
      title: 'Component Styles',
      component: 'CssSettings',
    },
  ],
};
